import { FC, memo, useCallback } from 'react';
// Types
import QuizTypes from 'types/QuizTypes';
// Models
import IQuiz from 'models/Quiz';
import IQuestion from 'models/Question';
// Redux
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
// Actions
import { setQuestionReady, setQuestionStart } from 'store/player/playerSlice';
// Selectors
import { selectQuiz, selectQuestion } from 'store/quiz/quizSelectors';
import { selectQuestionEnd } from 'store/player/playerSelectors';
// Components
import Video from 'components/Video';
import AudioPlayer from 'components/AudioPlayer';

const DEFAULT_AUDIO_IMAGE = 'https://media.quizwizards.com/question-default.jpg';

const QuestionMedia:FC = () => {
  const dispatch = useAppDispatch();

  const quiz:IQuiz = useAppSelector(selectQuiz);
  const question:IQuestion = useAppSelector(selectQuestion);
  const questionEnd = useAppSelector(selectQuestionEnd);

  const handleCallback = useCallback(() => {
    if (questionEnd) return
    dispatch(setQuestionReady(true));
    if ( [QuizTypes.Scoring, QuizTypes.Prediction, QuizTypes.Streak].includes(quiz.type) ) {
      dispatch(setQuestionStart(true));
    };
    // eslint-disable-next-line
  }, [questionEnd]);

  const isPollQuiz = [QuizTypes.Poll, QuizTypes.RankingPoll].includes(quiz.type);
  const isHasMedia = !!question.image || !!question.video || !!question.audio;

  if (isPollQuiz && !isHasMedia) return <div className="h-24" />;

  if (question.video) {
    return (
      <Video
        videoClasses="w-full aspect-video"
        videoUrl={question.video}
        onEndedCallback={handleCallback}
        isQuestionVideo={true}
      />
    );
  }

  const imageUrl = questionEnd && question.postAnswerImage ? question.postAnswerImage : question.image || (question.audio ? DEFAULT_AUDIO_IMAGE : null);

  return (
    <div className="w-full" style={{ maxHeight: 'max-content' }}>
      {imageUrl && (
        <img
          className="block max-w-full max-h-max mx-auto object-contain"
          src={imageUrl}
          alt=""
          onLoad={question.audio ? undefined : handleCallback}
        />
      )}
      {question.audio && (
        <AudioPlayer
          src={question.audio}
          onEnded={handleCallback}
          playbackRate={question.audioPlaybackRate}
          startTime={question.audioStartTime}
          endTime={question.audioEndTime}
        />
      )}
    </div>
  );
};

export default memo(QuestionMedia);
